export const API_URL_CHECK_CUSTOMER_AND_SET_ACCOUNT_ID = "/shop/api/checkout/checkcustomerandsetaccountid";
export const API_URL_CHECK_CUSTOMER_AND_SET_PERSONAL_DETAILS = "/shop/api/checkout/checkcustomerandsetpersonaldetails";
export const API_URL_CHECK_CUSTOMER_AND_SET_PERSONAL_DETAILS_FOR_NEW_MEMBER =
    "/shop/api/checkout/checkcustomerandsetpersonaldetailsfornewmember";
